import { render, staticRenderFns } from "./AssetOnlySetup.vue?vue&type=template&id=182de0d5&scoped=true"
import script from "./AssetOnlySetup.vue?vue&type=script&lang=ts"
export * from "./AssetOnlySetup.vue?vue&type=script&lang=ts"
import style0 from "./AssetOnlySetup.vue?vue&type=style&index=0&id=182de0d5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182de0d5",
  null
  
)

export default component.exports